// extracted by mini-css-extract-plugin
export var container = "_81-1";
export var cornerButtonContainer = "_81-5";
export var disabled = "_81-2";
export var fileContainer = "_81-4";
export var hiddenInput = "_81-3";
export var widthContainer = "_81-0";